import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TopNavigation, } from '@zurich/ui/legacy/components';
import { useAppImage, useAppLink } from '@zurich/ui/legacy/hooks';
import { styled } from '@zurich/ui/legacy/utils';
import Logo from '../../images/logo-full.svg';
import LogoMobile from '../../images/logo-icon.svg';
// TODO:  Wait for the final Design. Should be more generic. Most of the componet will be not used in Kundeportal.
export function Header(props) {
    const AppLink = useAppLink();
    const AppImage = useAppImage();
    return (_jsx(TopNavigation, { ...props, LogoComponent: _jsxs(AppLink, { href: "/", children: [_jsx(LogoDesktopStyled, { children: _jsx(AppImage, { alt: "logo", src: Logo, width: 133, height: 32, priority: true }) }), _jsx(LogoMobileStyled, { children: _jsx(AppImage, { alt: "logomobile", src: LogoMobile, width: 32, height: 32 }) })] }) }));
}
const LogoDesktopStyled = styled('div')(({ theme }) => ({
    width: '133px',
    display: 'flex',
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}));
const LogoMobileStyled = styled('div')(({ theme }) => ({
    width: '32px',
    display: 'flex',
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
}));
export default Header;
